import { Typography, useMediaQuery, useTheme } from "@mui/material";

import React from "react";

const useTruncateString = () => {
  const mainTheme = useTheme();

  const widthAboveMd = useMediaQuery(mainTheme.breakpoints.up("md"));

  const widthSmToMd = useMediaQuery(mainTheme.breakpoints.between("sm", "md"));

  const widthBelowSm = useMediaQuery(mainTheme.breakpoints.down("sm"));

  const handleTruncatedString = ({
    customText,
    customVariant,
    customComponent,
    customSx,
    maxCharacters,
  }) => {
    let appropriateNumOfChars;

    switch (true) {
      case widthAboveMd:
        appropriateNumOfChars = maxCharacters.aboveMd;
        break;

      case widthSmToMd:
        appropriateNumOfChars = maxCharacters.smToMd;
        break;

      case widthBelowSm:
        appropriateNumOfChars = maxCharacters.sm;
        break;

      default:
        appropriateNumOfChars = 15;
    }

    const truncatedString =
      customText.length <= appropriateNumOfChars
        ? customText
        : `${customText.substring(0, appropriateNumOfChars)}...`;

    return (
      <Typography
        variant={customVariant}
        component={customComponent}
        sx={customSx}
      >
        {truncatedString}
      </Typography>
    );
  };

  return handleTruncatedString;
};

export default useTruncateString;
